import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { EshopService } from 'src/app/eshop/eshop.service';
import { EshopLink, Product } from 'src/typings';

@Component({
  selector: 'app-add-eshop-link',
  templateUrl: './add-eshop-link.component.html',
  styleUrls: ['./add-eshop-link.component.scss']
})
export class AddEshopLinkComponent {
  @Input() product: Product | undefined;

  @Output() doneEvent: EventEmitter<EshopLink> = new EventEmitter();

  createForm: UntypedFormGroup = this.fb.group({
    eshop: new UntypedFormControl(),
    link: new UntypedFormControl()
  });

  get eshopControl() {
    return this.createForm.controls.eshop as UntypedFormControl;
  }

  constructor(private fb: UntypedFormBuilder, private eshopService: EshopService) {}

  async create() {
    if (!this.product) return;
    const newLink = await firstValueFrom(
      this.eshopService.createLink({
        link: this.createForm.value.link,
        eshop_id: this.createForm.value.eshop.id
      })
    );
    await this.eshopService
      .linkToProduct({
        link_id: newLink.id,
        product_id: this.product.id
      })
      .toPromise();
    this.doneEvent.emit(newLink);
    return;
  }
}
